import React from "react";
import { Link } from "react-router-dom";
import styles from "./AdLink.scss";
import { PageRoute } from "../../../models";

const AdLink = ({ children, className, ad, onClick, target }) => {
  return (
    <Link
      className={className ? `${styles.link} ${className}` : styles.link}
      title={ad.title}
      to={`/${ad.module}/${ad.category}${PageRoute.details}/${ad.link}`}
      onClick={onClick}
      target={target}
    >
      {children}
    </Link>
  );
};

AdLink.defaultProps = {
  className: ""
};

export default AdLink;



// WEBPACK FOOTER //
// ./src/components/SimilarAdCard/AdLink/AdLink.tsx